import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './notification-template.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const NotificationTemplateDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const notificationTemplateEntity = useAppSelector(state => state.notificationTemplate.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="notificationTemplateDetailsHeading">
          <Translate contentKey="comexApp.notificationTemplate.detail.title">NotificationTemplate</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{notificationTemplateEntity.id}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="comexApp.notificationTemplate.type">Type</Translate>
            </span>
          </dt>
          <dd>{notificationTemplateEntity.type}</dd>
          <dt>
            <span id="medium">
              <Translate contentKey="comexApp.notificationTemplate.medium">Medium</Translate>
            </span>
          </dt>
          <dd>{notificationTemplateEntity.medium}</dd>
          <dt>
            <span id="language">
              <Translate contentKey="comexApp.notificationTemplate.language">Language</Translate>
            </span>
          </dt>
          <dd>{notificationTemplateEntity.language}</dd>
          <dt>
            <span id="message">
              <Translate contentKey="comexApp.notificationTemplate.message">Message</Translate>
            </span>
          </dt>
          <dd>{notificationTemplateEntity.message}</dd>
        </dl>
        <Button tag={Link} to="/notification-template" replace data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/notification-template/${notificationTemplateEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NotificationTemplateDetail;
